import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, Dialog, IconButton, Switch, Typography } from "@mui/material";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { useSelector } from "react-redux";
import { EditOutlined } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";

import SystemModal from "./SystemModal";
import SystemView from "./SystemView";

const System = () => {
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);
  const [view, setView] = useState(false);
  const [viewId, setViewId] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const link = masterAPI["system"].link;
    try {
      const res = await axiosPrivate.get(`${link}`);
   
      if (filterValue === "enableData") {
        const filterDataResult = res.data.result.filter((fil) => fil.isActive);
        setData(filterDataResult);
        setBackUpData(res.data.result);
      } else {
        setData(res.data.result);
        setBackUpData(res.data.result);
      }
    } catch (e) {
      console.log(e, "system");
      setData([]);
      setBackUpData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  const handleView = (id) => {
    setView(true);
    setViewId(id);
  };

  const handleCloseView = () => {
    setView(false);
    setViewId("");
    getData();
  };

  const handleDelete = async (e, id) => {
    const enableLink = masterAPI["system"].enable;
    const disableLink = masterAPI["system"].disable;
    try {
      if (e.target.checked) {
        const res = await axiosPrivate.put(`${enableLink}/${id}`);
        console.log(res.data);
      } else {
        const res = await axiosPrivate.put(`${disableLink}/${id}`);
        console.log(res.data);
      }
      getData();
    } catch (e) {
      console.log(e, "enable/disable");
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: () => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox />
          </Box>
        );
      },
    },
    {
      Header: "System Code",
      accessor: "systemCode",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: "#0d6efd",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => handleView(cell.row.original.id)}
          >
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header: "System Name",
      accessor: "systemName",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={!actionsAllow.edit}>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.edit ? color.masterEditDelButtonColor : "default",
                }}
              />
            </IconButton>
            <Switch
              disabled={!actionsAllow.delete}
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
          </Box>
        );
      },
    },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);
      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["system"].title}
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
      />

      <Dialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"lg"}
        children={
          <SystemModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />

      <Dialog
        open={view}
        onClose={handleCloseView}
        maxWidth={"lg"}
       
        children={<SystemView handleCloseClick={handleCloseView} viewId={viewId} />}
      />
    </>
  );
};

export default System;
